module.exports = __webpack_public_path__ + "static/man-3-f3c0c58e8495c5abb88dcd2b901dd72d.jpg";